module.exports = __webpack_public_path__ + "img/isamilo_lodge_gallery_41.d0877962.jpg";